import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { xpcellService } from 'services';

import BarChartWithLegend from './DashboardPieWithLegend';

export const ServiceOrderByStatusDashboard = () => {
  const [quantityServiceOrders, setQuantityServiceOrders] = useState([]);

  const fetchData = async () => {
    try {
      const { data } = await xpcellService.getServiceOrderByStatus();
      setQuantityServiceOrders(data);
    } catch (error) {
      toast.error('Ocorreu um erro ao consultar dados!');
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
    const intervalId = setInterval(fetchData, 10000);
    return () => clearInterval(intervalId);
  }, []);
  return (
    <>
      <BarChartWithLegend data={quantityServiceOrders} />
    </>
  );
};
